// frontend/src/components/SupplierInvoices/SupplierInvoiceStats.jsx
import React from 'react';
import { DollarSign, CheckCircle, Clock, Inbox, AlertTriangle } from 'lucide-react';

const fmt = (val) =>
  val != null ? `$${parseFloat(val).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : '—';

const StatCard = ({ title, value, icon: Icon, color }) => (
  <div className="bg-gray-800/50 rounded-xl p-3 sm:p-5 border border-gray-700">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-400 text-xs sm:text-sm">{title}</p>
        <p className="text-lg sm:text-2xl font-bold text-white mt-1">{value}</p>
      </div>
      <div className={`p-2 sm:p-3 rounded-xl bg-${color}-500/20`}>
        <Icon className={`w-4 h-4 sm:w-6 sm:h-6 text-${color}-400`} />
      </div>
    </div>
  </div>
);

const SupplierInvoiceStats = ({ stats }) => (
  // Mobile : 2 colonnes sur les 4 premières cards + Overdue pleine largeur
  // Desktop : 5 colonnes égales
  <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
    <StatCard title="Total This Year" value={fmt(stats.total_amount)}    icon={DollarSign}    color="blue"   />
    <StatCard title="Paid"            value={fmt(stats.paid_amount)}     icon={CheckCircle}   color="green"  />
    <StatCard title="Pending"         value={fmt(stats.pending_amount)}  icon={Clock}         color="yellow" />
    <StatCard title="Received"        value={fmt(stats.received_amount)} icon={Inbox}         color="purple" />
    {/* Sur mobile : pleine largeur pour éviter la card orpheline */}
    <div className="col-span-2 lg:col-span-1">
      <StatCard title="Overdue" value={stats.overdue_count ?? '—'} icon={AlertTriangle} color="red" />
    </div>
  </div>
);

export default SupplierInvoiceStats;